/**
 * DADDL footer — mobile menu accordion.
 * Newsletter uses snippets/daddl-field + daddl-button.
 */
(function () {
  'use strict';

  function bindFooter(root) {
    root.querySelectorAll('[data-daddl-footer-menu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const menu = button.closest('[data-daddl-footer-menu]');
        if (!menu) return;
        const open = menu.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  document.querySelectorAll('[data-daddl-footer]').forEach(bindFooter);
})();
